<template>
    <div>
        <template>
            <template v-if="purchase.actions.supplier.supplementary_agreement === 'sign'">
                <b-row>
                    <b-col>
                        <fl44-unknown-volume-supplier-sign-supplementary-agreement-button :supplementary-agreement="supplementaryAgreement" :purchase="purchase" class="mb-3" @refresh="$emit('refresh')" />
                    </b-col>
                </b-row>
                <template v-if="purchase.actions.supplier.can_store_supplementary_agreement_disagreement">
                    <text-header margin-class="mb-3">Согласование разногласий по дополнительному соглашению</text-header>
                    <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <form-row-single-line-document-upload v-model="form.attachment" :disabled="!$store.getters.getCanSign" :label-cols-lg="3" :v="$v.form.attachment" title="Протокол разногласий" />
                        <form-row-edit-textarea v-model="form.comment" :v="$v.form.comment" label="Комментарий" />
                    </b-overlay>
                    <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-btn :disabled="!$store.getters.getCanSign || $v.$invalid" class="mr-2 mb-2" variant="custom-green" @click="showDisagreementModal = true">Подписать и отправить протокол разногласий</b-btn>
                    </b-overlay>
                    <template v-if="!$store.getters.getCanSign">
                        <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">
                            Для действия требуется загрузить/заменить МЧД на странице:
                            <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link>
                        </span>
                        <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                    </template>
                    <sign-file-modal
                        v-if="form.attachment"
                        :attachment="form.attachment"
                        :show="showDisagreementModal"
                        title="Отправка подписанного протокола разногласий"
                        :is-sending="isDataSending"
                        @close="showDisagreementModal = false"
                        @submit="storeSignedDisagreement" />
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { getCertificate } from 'crypto-pro';
import Fl44UnknownVolumeSupplierSignSupplementaryAgreementButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplier-sign-supplementary-agreement-button.vue';

export default {
    name: 'private-fl44-unknown-volume-supplementary-agreement-supplier-block',
    components: { Fl44UnknownVolumeSupplierSignSupplementaryAgreementButton },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showConfirmModal: false,
            showDisagreementModal: false,
            form: {
                attachment: null,
                comment: ''
            },
            isDataSending: false,
            fields: [
                { key: 'created_at', label: 'Дата и время', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '200px', maxWidth: '200px' } },
                { key: 'contract_attachment', label: 'Документ', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'sign_customer', label: 'Подпись заказчика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } },
                { key: 'sign_supplier', label: 'Подпись поставщика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } }
            ]
        };
    },
    validations() {
        return {
            form: {
                attachment: {
                    required
                },
                comment: {
                    required
                }
            }
        };
    },
    methods: {
        async storeSignedDisagreement(signature) {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                comment: this.form.comment,
                type: this.supplementaryAgreement.type.id,
                signed_attachment: {
                    id: this.form.attachment.id,
                    md5: signature.signature
                }
            };
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements.storeSignedDisagreement(this.purchase.id, this.purchase.contract.id, this.supplementaryAgreement.id, 'supplier', data)
                .then((result) => {
                    if (result) {
                        this.showDisagreementModal = false;
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
